import React from 'react'
import MyNavbar from './MyNavbar'
import Intro1 from './Intro1'
import Intro2 from './Intro2'
import Timeline from './Timeline'
import Skills from './Skills'

const index = () => {
    return (
        <>
            <MyNavbar />
            <Intro1 />
            <Intro2 />
            <Timeline />
            <Skills />
        </>
    )
}

export default index
